import { render, staticRenderFns } from "./ProdSquarePlugin.vue?vue&type=template&id=4a390cdc&scoped=true&"
import script from "./ProdSquarePlugin.vue?vue&type=script&lang=js&"
export * from "./ProdSquarePlugin.vue?vue&type=script&lang=js&"
import style0 from "./ProdSquarePlugin.vue?vue&type=style&index=0&id=4a390cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a390cdc",
  null
  
)

export default component.exports